import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MoodBoard from '../components/experiments/MoodBoard';
import TextDelta from '../components/experiments/TextDelta';
import FilmSlider from '../components/experiments/FilmSlider';

import { Grid } from "react-bootstrap";

import * as experimentsActions from '../actions/actionsExperiments';

class ExperimentsContainer extends Component {
  render() {
    const { match, location } = this.props;

    return (
      <Grid fluid className="main-container experiments">
        {location.pathname.indexOf('/experiments/mood-board') === -1 && (
          <div className="selector">
            <Link to={`${match.path}/mood-board`}>Story Moodboard</Link>
            <Link to={`${match.path}/textdelta`}>Text Delta</Link>
            <Link to={`${match.path}/filmslider`}>Mood Slider</Link>
          </div>
        )}

        <Route path='/experiments/mood-board/:movieId?' component={MoodBoard} />
        <Route path='/experiments/textdelta' component={TextDelta} />
        <Route path='/experiments/filmslider' component={FilmSlider} />
      </Grid>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    experiments: state.experiments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(experimentsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperimentsContainer);



// WEBPACK FOOTER //
// ./src/containers/ExperimentsContainer.js